var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _g, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 530 310",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_146_3690)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-25.8143 68.9894L-150.312 159.575V308.369H98.6837V159.575L-25.8143 68.9894Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-25.8143 68.9894L-150.312 159.575V308.369H98.6837V159.575L-25.8143 68.9894Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-74.5488 228.946H-8.85598H2.37133H9.85652L2.37133 208.911L-10.5282 174.487H-74.5488",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-74.5488 228.946H-8.85598H2.37133H9.85652L2.37133 208.911L-10.5282 174.487H-74.5488",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M336.808 105.454L231.275 182.241V308.369H442.34V182.241L336.808 105.454Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M336.808 105.454L231.275 182.241V308.369H442.34V182.241L336.808 105.454Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.577 126.952H142.401V166.158H111.577V126.952Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M106.752 127.755H147.226V113.304H106.752V127.755Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9971 203.228V308.208H281.263V203.228L186.13 137.414L90.9971 203.228Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9971 203.228V308.208H281.263V203.228L186.13 137.414L90.9971 203.228Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M186.13 116.09L292.844 190.184L281.47 206.649L186.13 140.504L90.7893 206.649L79.416 190.184L186.13 116.09Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M186.13 116.09L292.844 190.184L281.47 206.649L186.13 140.504L90.7893 206.649L79.416 190.184L186.13 116.09Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M186.13 108.186L300.407 187.531L288.227 205.163L186.13 134.33L84.0329 205.163L71.8535 187.531L186.13 108.186Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M186.13 108.186L300.407 187.531L288.227 205.163L186.13 134.33L84.0329 205.163L71.8535 187.531L186.13 108.186Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M113.94 269.669H174.886V213.277H113.94V269.669Z",
    fill: "#231F20"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M194.721 308.208H254.345V213.278H194.721V308.208Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M198.801 308.208H250.265V217.473H198.801V308.208Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M203.688 255.136H245.379V221.311H203.688V255.136Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M203.688 301.026H245.379V271.601H203.688V301.026Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M202.275 263.475C202.275 265.49 203.912 267.124 205.93 267.124C207.948 267.124 209.584 265.49 209.584 263.475C209.584 261.46 207.948 259.827 205.93 259.827C203.912 259.827 202.275 261.46 202.275 263.475Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M202.275 263.475C202.275 265.49 203.912 267.124 205.93 267.124C207.948 267.124 209.584 265.49 209.584 263.475C209.584 261.46 207.948 259.827 205.93 259.827C203.912 259.827 202.275 261.46 202.275 263.475Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M196.707 68.9679H199.627C200.107 61.9799 206.053 56.4525 213.337 56.4525C214.98 56.4525 216.549 56.7481 218.009 57.2632C217.997 56.9926 217.967 56.7263 217.967 56.4525C217.967 46.6474 226.114 38.6989 236.163 38.6989C238.862 38.6989 241.415 39.2878 243.719 40.3166C248.204 36.0635 254.315 33.4342 261.063 33.4342C271.103 33.4342 279.733 39.2445 283.672 47.596C284.424 47.5082 285.186 47.4498 285.962 47.4498C296.541 47.4498 305.116 55.8169 305.116 66.1379C305.116 67.2623 304.997 68.3576 304.802 69.4271C309.397 70.7873 312.778 75.0455 312.778 80.0601C312.778 86.1607 307.778 91.1523 301.668 91.1523H196.707C190.597 91.1523 185.598 86.1607 185.598 80.0601C185.598 73.9595 190.597 68.9679 196.707 68.9679Z",
    fill: "#E5E6E3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M196.707 68.9679H199.627C200.107 61.9799 206.053 56.4525 213.337 56.4525C214.98 56.4525 216.549 56.7481 218.009 57.2632C217.997 56.9926 217.967 56.7263 217.967 56.4525C217.967 46.6474 226.114 38.6989 236.163 38.6989C238.862 38.6989 241.415 39.2878 243.719 40.3166C248.204 36.0635 254.315 33.4342 261.063 33.4342C271.103 33.4342 279.733 39.2445 283.672 47.596C284.424 47.5082 285.186 47.4498 285.962 47.4498C296.541 47.4498 305.116 55.8169 305.116 66.1379C305.116 67.2623 304.997 68.3576 304.802 69.4271C309.397 70.7873 312.778 75.0455 312.778 80.0601C312.778 86.1607 307.778 91.1523 301.668 91.1523H196.707C190.597 91.1523 185.598 86.1607 185.598 80.0601C185.598 73.9595 190.597 68.9679 196.707 68.9679Z",
    stroke: "#040606",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M113.305 29.3704H110.897C110.501 23.6068 105.597 19.0482 99.5889 19.0482C98.2338 19.0482 96.9402 19.2919 95.7357 19.717C95.7458 19.4936 95.7701 19.274 95.7701 19.0482C95.7701 10.9612 89.0513 4.40578 80.7629 4.40578C78.5368 4.40578 76.4311 4.89136 74.5311 5.74005C70.8323 2.23225 65.7923 0.0638199 60.2264 0.0638199C51.9458 0.0638199 44.8283 4.85578 41.5795 11.7438C40.9591 11.6714 40.3309 11.6235 39.6904 11.6235C30.9658 11.6235 23.8934 18.5238 23.8934 27.0361C23.8934 27.9635 23.9917 28.8671 24.1526 29.7492C20.3621 30.8709 17.5742 34.3831 17.5742 38.519C17.5742 43.5504 21.6976 47.6675 26.7372 47.6675H113.305C118.344 47.6675 122.468 43.5504 122.468 38.519C122.468 33.4874 118.344 29.3704 113.305 29.3704Z",
    fill: "#E5E6E3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M113.305 29.3704H110.897C110.501 23.6068 105.597 19.0482 99.5889 19.0482C98.2338 19.0482 96.9402 19.2919 95.7357 19.717C95.7459 19.4936 95.7701 19.274 95.7701 19.0482C95.7701 10.9612 89.0513 4.40578 80.7629 4.40578C78.5368 4.40578 76.4311 4.89136 74.5311 5.74005C70.8323 2.23226 65.7923 0.0638194 60.2264 0.0638194C51.9458 0.0638194 44.8283 4.85578 41.5795 11.7438C40.9591 11.6714 40.3309 11.6235 39.6904 11.6235C30.9658 11.6235 23.8934 18.5238 23.8934 27.0361C23.8934 27.9635 23.9917 28.8671 24.1526 29.7492C20.3621 30.8709 17.5742 34.3831 17.5742 38.519C17.5742 43.5504 21.6976 47.6675 26.7372 47.6675H113.305C118.344 47.6675 122.468 43.5504 122.468 38.519C122.468 33.4874 118.344 29.3704 113.305 29.3704Z",
    stroke: "#040606",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M0.954704 194.689C0.954704 232.851 -15.1457 263.787 -35.006 263.787C-54.8667 263.787 -70.9668 232.851 -70.9668 194.689C-70.9668 156.527 -54.8667 125.591 -35.006 125.591C-15.1457 125.591 0.954704 156.527 0.954704 194.689Z",
    fill: "#231F20"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M53.8668 182.19C53.8668 199.245 40.0196 213.07 22.9382 213.07C5.85696 213.07 -7.99023 199.245 -7.99023 182.19C-7.99023 165.136 5.85696 151.311 22.9382 151.311C40.0196 151.311 53.8668 165.136 53.8668 182.19Z",
    fill: "#231F20"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M80.3852 210.715C80.3852 223.665 69.8703 234.163 56.8999 234.163C43.9297 234.163 33.415 223.665 33.415 210.715C33.415 197.765 43.9297 187.267 56.8999 187.267C69.8703 187.267 80.3852 197.765 80.3852 210.715Z",
    fill: "#231F20"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M18.4706 229.01C18.4706 238.05 11.1306 245.378 2.07636 245.378C-6.97767 245.378 -14.3174 238.05 -14.3174 229.01C-14.3174 219.97 -6.97767 212.642 2.07636 212.642C11.1306 212.642 18.4706 219.97 18.4706 229.01Z",
    fill: "#231F20"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6516 202.985L24.0508 247.416",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0505 255.746L2.0752 227.533",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0498 165.906V308.238",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0293 308.238V257.092L33.8593 250.635L38.6863 257.092V308.238H29.0293Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0293 308.238V257.092L33.8593 250.635L38.6863 257.092V308.238H29.0293Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3799 308.238V257.092L53.2077 250.635L58.0369 257.092V308.238H48.3799Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3799 308.238V257.092L53.2077 250.635L58.0369 257.092V308.238H48.3799Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7295 308.238V257.092L72.5594 250.635L77.3865 257.092V308.238H67.7295Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7295 308.238V257.092L72.5594 250.635L77.3865 257.092V308.238H67.7295Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M-9.6709 308.238V257.092L-4.84069 250.635L-0.0138781 257.092V308.238H-9.6709Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67969 308.238V257.092L14.5075 250.635L19.3367 257.092V308.238H9.67969Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67969 308.238V257.092L14.5075 250.635L19.3367 257.092V308.238H9.67969Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M91.153 294.906H-74.5488V284.567H91.153V294.906Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M91.153 276.045H-74.5488V265.706H91.153V276.045Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M546.106 15.6812H510.835V60.5435H546.106V15.6812Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M551.626 16.5999H505.313V0.0635395H551.626V16.5999Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M581.305 308.369H324.166V130.374L452.736 41.4268L581.305 130.374V308.369Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M581.305 308.369H324.166V130.374L452.736 41.4268L581.305 130.374V308.369Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M322.192 125.065L323.885 134.997H581.586L583.278 125.065H322.192Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M322.192 125.065L323.885 134.997H581.586L583.278 125.065H322.192Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M556.566 40.3705H348.906L314.754 125.744H590.718L556.566 40.3705Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M556.566 40.3705H348.906L314.754 125.744H590.718L556.566 40.3705Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M318.859 115.48H586.185",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M322.913 105.341H360.35H545.12H582.557",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M326.971 95.2031H375.006H530.468H578.5",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M331.026 85.0647H389.662H515.812H574.445",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M335.081 74.9263H404.314H501.157H570.39",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M339.139 64.7878H418.969H486.504H566.332",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M343.194 54.6494H433.625H471.849H510.835H546.106H562.277",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M347.249 44.511H448.28H457.193H510.834H546.106H558.221",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M452.736 44.4261L418.752 72.9512V115.48H452.736H486.719V72.9512L452.736 44.4261Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M452.736 44.4261L418.752 72.9512V115.48H452.736H486.719V72.9512L452.736 44.4261Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M452.736 32.4748L405.406 73.1414L418.752 72.9511L452.736 44.4257L486.719 72.9511L500.065 73.1414L452.736 32.4748Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M452.736 32.4748L405.406 73.1414L418.752 72.9511L452.736 44.4257L486.719 72.9511L500.065 73.1414L452.736 32.4748Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M479.903 297.757H432.3V177.589H479.903V297.757Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M429.605 174.898V300.446H434.998V295.067H434.996V180.279H477.209V295.067H477.18V300.446H482.599V174.898H429.605Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M429.605 174.898V300.446H434.998V295.067H434.996V180.279H477.209V295.067H477.18V300.446H482.599V174.898H429.605Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M486.416 308.369H425.789V297.757H486.416V308.369Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M472.045 227.397H440.159V187.268H472.045V227.397Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M472.045 287.778H440.159V247.651H472.045V287.778Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M473.586 239.506C473.586 240.975 472.394 242.162 470.924 242.162C469.455 242.162 468.263 240.975 468.263 239.506C468.263 238.039 469.455 236.847 470.924 236.847C472.394 236.847 473.586 238.039 473.586 239.506Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M473.586 239.506C473.586 240.975 472.394 242.162 470.924 242.162C469.455 242.162 468.263 240.975 468.263 239.506C468.263 238.039 469.455 236.847 470.924 236.847C472.394 236.847 473.586 238.039 473.586 239.506Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M397.627 258.642H358.951V174.898H397.627V258.642Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M551.734 258.642H513.059V174.898H551.734V258.642Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M470.803 107.192H434.241V70.6867H470.803V107.192Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M467.818 103.997H437.653V73.8806H467.818V103.997Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M467.818 86.7596H437.653V90.1665H467.818V86.7596Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M450.816 103.997H454.229V73.8806H450.816V103.997Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M315.461 150.999C315.461 173.232 297.41 191.255 275.142 191.255C252.874 191.255 234.822 173.232 234.822 150.999C234.822 128.766 252.874 110.743 275.142 110.743C297.41 110.743 315.461 128.766 315.461 150.999Z",
    fill: "#231F20"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M350.032 188.184C350.032 205.067 336.324 218.752 319.416 218.752C302.507 218.752 288.8 205.067 288.8 188.184C288.8 171.302 302.507 157.617 319.416 157.617C336.324 157.617 350.032 171.302 350.032 188.184Z",
    fill: "#231F20"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.149994,
    d: "M269.318 212.035C269.318 223.82 259.75 233.373 247.946 233.373C236.143 233.373 226.574 223.82 226.574 212.035C226.574 200.25 236.143 190.697 247.946 190.697C259.75 190.697 269.318 200.25 269.318 212.035Z",
    fill: "#231F20"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M321.7 178.108L276.593 236.03",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M276.593 246.893L247.946 210.109",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M276.591 129.769V191.228V191.23V229.07V236.03V237.736V246.891V252.226V253.877V259.082V259.457V259.992V262.313V265.726V267.222V267.329V269.943V277.171V278.871V279.488V280.001V281.187V281.7V282.317V284.017V291.543V293.145V293.562V299.79V301.191V304.994V308.369",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1923 308.239H88.5459V136.417H93.1923V308.239Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9053 308.239H82.832V298.609H98.9053V308.239Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M130.827 152.784H91.125V136.417H130.827L137.027 144.6L130.827 152.784Z",
    fill: "#F14A25"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M130.827 152.784H91.125V136.417H130.827L137.027 144.6L130.827 152.784Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1671 178.578H90.869V162.211H51.1671L44.9668 170.395L51.1671 178.578Z",
    fill: "#F14A25"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1671 178.578H90.869V162.211H51.1671L44.9668 170.395L51.1671 178.578Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1671 207.468H90.869V191.101H51.1671L44.9668 199.284L51.1671 207.468Z",
    fill: "#F14A25"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1671 207.468H90.869V191.101H51.1671L44.9668 199.284L51.1671 207.468Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M384.053 213.102H358.64C357.393 213.102 356.183 213.52 355.203 214.289L338.579 227.332C334.418 230.596 336.727 237.279 342.016 237.279H384.053V213.102Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M285.475 274.205V280.257C285.475 287.099 291.021 292.646 297.864 292.646H434.34C447.093 292.646 458.054 285.08 463.054 274.205H285.475Z",
    fill: "#F14E1C"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M416.808 297.246C410.445 297.246 405.287 292.088 405.287 285.725C405.287 279.363 410.445 274.205 416.808 274.205C423.17 274.205 428.328 279.363 428.328 285.725C428.328 292.088 423.17 297.246 416.808 297.246ZM416.808 263.784C404.689 263.784 394.865 273.608 394.865 285.725C394.865 297.844 404.689 307.667 416.808 307.667C428.926 307.667 438.75 297.844 438.75 285.725C438.75 273.608 428.926 263.784 416.808 263.784Z",
    fill: "#F84800"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M334.679 297.246C328.316 297.246 323.159 292.088 323.159 285.725C323.159 279.363 328.316 274.205 334.679 274.205C341.041 274.205 346.199 279.363 346.199 285.725C346.199 292.088 341.041 297.246 334.679 297.246ZM334.679 263.784C322.56 263.784 312.736 273.608 312.736 285.725C312.736 297.844 322.56 307.667 334.679 307.667C346.797 307.667 356.621 297.844 356.621 285.725C356.621 273.608 346.797 263.784 334.679 263.784Z",
    fill: "#F84800"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M396.008 292.636H355.286",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_146_3690",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 284,
    y: 194,
    width: 183,
    height: 100
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M313.871 292.636H297.804C291.017 292.636 285.477 287.096 285.477 280.17V259.394C285.477 255.515 287.139 252.053 290.186 249.698L350.576 202.189C356.255 197.757 363.181 195.402 370.383 195.402H453.49C460.415 195.402 465.955 200.942 465.955 207.729V261.056C465.955 277.4 453.489 290.836 437.561 292.498",
    fill: "black"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M313.871 292.636H297.804C291.017 292.636 285.477 287.096 285.477 280.17V259.394C285.477 255.515 287.139 252.053 290.186 249.698L350.576 202.189C356.255 197.757 363.181 195.402 370.383 195.402H453.49C460.415 195.402 465.955 200.942 465.955 207.729V261.056C465.955 277.4 453.489 290.836 437.561 292.498",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_146_3690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M946.33 689.312H235.107V177.436H946.33V689.312Z",
    fill: "#F84800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.429 267.424V255.337L276.379 253.068V265.156L267.305 261.753L257.85 275.325L282.047 284.399L291.502 270.827L282.429 267.424Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.351 206.163V194.075L295.302 191.806V203.894L286.228 200.491L276.772 214.063L300.97 223.137L310.425 209.565L301.351 206.163Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.578 274.23L306.628 276.499L299.876 286.293L293.826 284.024L300.578 274.23Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.093 245.868V233.78L310.044 231.512V243.599L300.97 240.197L291.514 253.768L315.711 262.842L325.167 249.271L316.093 245.868Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.848 234.526L291.897 236.794L285.145 246.588L279.096 244.32L285.848 234.526Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.159 307.129V295.042L291.11 292.773V304.861L282.036 301.458L272.58 315.03L296.777 324.104L306.233 310.532L297.159 307.129Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.824 285.573V273.486L324.775 271.217V283.305L315.701 279.902L306.245 293.473L330.442 302.548L339.898 288.976L330.824 285.573Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.007 184.608V172.52L328.957 170.252V182.34L319.884 178.937L310.428 192.509L334.625 201.583L344.081 188.011L335.007 184.608Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.233 252.676L340.282 254.944L333.53 264.739L327.48 262.47L334.233 252.676Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.748 224.313V212.226L343.699 209.957V222.045L334.625 218.642L325.169 232.214L349.366 241.288L358.822 227.716L349.748 224.313Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.502 212.971L325.551 215.24L318.799 225.034L312.75 222.766L319.502 212.971Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.897 231.12L373.946 233.388L367.194 243.182L361.145 240.914L367.897 231.12Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.412 202.757V190.67L377.363 188.401V200.489L368.289 197.086L358.833 210.658L383.03 219.732L392.486 206.16L383.412 202.757Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.167 191.415L359.216 193.683L352.464 203.478L346.414 201.209L353.167 191.415Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.561 209.563L407.61 211.832L400.858 221.626L394.809 219.357L401.561 209.563Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.076 181.201V169.113L411.027 166.845V178.932L401.953 175.529L392.497 189.101L416.694 198.175L426.15 184.604L417.076 181.201Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.225 188.007L441.274 190.275L434.522 200.07L428.473 197.801L435.225 188.007Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.479 264.019V251.931L358.43 249.663V261.75L349.356 258.348L339.9 271.919L364.097 280.993L373.553 267.422L364.479 264.019Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.221 303.724V291.637L373.171 289.368V301.456L364.097 298.053L354.642 311.624L378.839 320.699L388.294 307.127L379.221 303.724Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.975 292.382L355.024 294.65L348.272 304.445L342.223 302.176L348.975 292.382Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.144 242.462V230.375L392.094 228.106V240.194L383.02 236.791L373.564 250.363L397.762 259.437L407.217 245.865L398.144 242.462Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.885 282.168V270.08L406.836 267.812V279.899L397.762 276.496L388.306 290.068L412.503 299.142L421.959 285.571L412.885 282.168Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.639 270.826L388.688 273.094L381.936 282.888L375.887 280.62L382.639 270.826Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.807 220.906V208.818L425.757 206.55V218.638L416.683 215.235L407.228 228.806L431.425 237.88L440.88 224.309L431.807 220.906Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.034 288.974L437.083 291.242L430.331 301.037L424.281 298.768L431.034 288.974Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.549 260.611V248.524L440.499 246.255V258.343L431.426 254.94L421.97 268.512L446.167 277.586L455.623 264.014L446.549 260.611Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.303 249.269L422.353 251.537L415.601 261.332L409.551 259.063L416.303 249.269Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.472 199.35V187.262L459.422 184.994V197.081L450.348 193.678L440.893 207.25L465.09 216.324L474.545 202.753L465.472 199.35Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.213 239.055V226.968L474.164 224.699V236.787L465.09 233.384L455.634 246.956L479.831 256.029L489.287 242.458L480.213 239.055Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.967 227.713L456.016 229.981L449.264 239.775L443.215 237.507L449.967 227.713Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.273 300.315V288.227L455.224 285.959V298.046L446.15 294.644L436.694 308.215L460.891 317.289L470.347 303.718L461.273 300.315Z",
    fill: "#FF6F12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.157 185.002V197.089L286.23 200.491V183.433L262.033 174.359V191.417L271.107 194.82V182.733L277.157 185.002Z",
    fill: "#FF9C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.626 264.412V276.499L315.7 279.901V262.843L291.503 253.769V270.827L300.577 274.23V262.143L306.626 264.412Z",
    fill: "#FF9C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.896 224.707V236.794L300.97 240.197V223.138L276.772 214.064V231.123L285.847 234.526V222.439L291.896 224.707Z",
    fill: "#FF9C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.281 242.857V254.944L349.354 258.347V241.289L325.157 232.215V249.273L334.231 252.676V240.589L340.281 242.857Z",
    fill: "#FF9C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.551 203.153V215.24L334.625 218.642V201.584L310.428 192.51V209.568L319.502 212.971V200.884L325.551 203.153Z",
    fill: "#FF9C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.946 221.301V233.388L383.02 236.79L383.019 219.732L358.822 210.658V227.717L367.896 231.12V219.033L373.946 221.301Z",
    fill: "#FF9C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.215 181.596V193.683L368.289 197.086V180.028L344.092 170.954V188.012L353.166 191.415V179.328L359.215 181.596Z",
    fill: "#FF9C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.608 199.744V211.831L416.682 215.234V198.176L392.485 189.102V206.16L401.559 209.563V197.476L407.608 199.744Z",
    fill: "#FF9C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.024 282.563V294.65L364.098 298.053V280.995L339.9 271.92V288.979L348.974 292.382V280.295L355.024 282.563Z",
    fill: "#FF9C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.418 300.712V312.798L412.492 316.201V299.143L388.295 290.069V307.127L397.369 310.53V298.443L403.418 300.712Z",
    fill: "#FF9C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.688 261.007V273.094L397.762 276.496V259.438L373.564 250.364V267.423L382.639 270.825V258.738L388.688 261.007Z",
    fill: "#FF9C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.081 279.155V291.242L446.155 294.645V277.587L421.958 268.512V285.571L431.032 288.974V276.887L437.081 279.155Z",
    fill: "#FF9C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.351 239.45V251.537L431.425 254.94V237.882L407.228 228.808V245.866L416.302 249.269V237.182L422.351 239.45Z",
    fill: "#FF9C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.745 257.599V269.686L479.819 273.089V256.03L455.622 246.956V264.015L464.696 267.417V255.33L470.745 257.599Z",
    fill: "#FF9C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.016 217.894V229.981L465.09 233.384V216.326L440.893 207.251V224.31L449.967 227.713V215.626L456.016 217.894Z",
    fill: "#FF9C5E"
  }))), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M313.871 292.636H297.804C291.017 292.636 285.477 287.096 285.477 280.17V259.394C285.477 255.515 287.139 252.053 290.186 249.698L350.576 202.189C356.255 197.757 363.181 195.402 370.383 195.402H453.49C460.415 195.402 465.955 200.942 465.955 207.729V261.056C465.955 277.4 453.489 290.836 437.561 292.498",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M425.926 292.636H407.643",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M343.789 292.636H325.506",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M383.992 213.084H358.579C357.333 213.084 356.123 213.503 355.142 214.272L338.519 227.314C334.357 230.579 336.666 237.262 341.955 237.262H383.992V213.084Z",
    fill: "white",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M416.745 297.229C410.383 297.229 405.225 292.071 405.225 285.708C405.225 279.345 410.383 274.187 416.745 274.187C423.108 274.187 428.266 279.345 428.266 285.708C428.266 292.071 423.108 297.229 416.745 297.229ZM416.745 263.766C404.627 263.766 394.803 273.591 394.803 285.708C394.803 297.826 404.627 307.65 416.745 307.65C428.863 307.65 438.688 297.826 438.688 285.708C438.688 273.591 428.863 263.766 416.745 263.766Z",
    fill: "#231F20"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M416.745 297.229C410.383 297.229 405.225 292.071 405.225 285.708C405.225 279.345 410.383 274.187 416.745 274.187C423.108 274.187 428.266 279.345 428.266 285.708C428.266 292.071 423.108 297.229 416.745 297.229ZM416.745 263.766C404.627 263.766 394.803 273.591 394.803 285.708C394.803 297.826 404.627 307.65 416.745 307.65C428.863 307.65 438.688 297.826 438.688 285.708C438.688 273.591 428.863 263.766 416.745 263.766Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M334.617 297.229C328.255 297.229 323.097 292.071 323.097 285.708C323.097 279.345 328.255 274.187 334.617 274.187C340.979 274.187 346.137 279.345 346.137 285.708C346.137 292.071 340.979 297.229 334.617 297.229ZM334.617 263.766C322.498 263.766 312.675 273.591 312.675 285.708C312.675 297.826 322.498 307.65 334.617 307.65C346.735 307.65 356.56 297.826 356.56 285.708C356.56 273.591 346.735 263.766 334.617 263.766Z",
    fill: "#231F20"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M334.617 297.229C328.255 297.229 323.097 292.071 323.097 285.708C323.097 279.345 328.255 274.187 334.617 274.187C340.979 274.187 346.137 279.345 346.137 285.708C346.137 292.071 340.979 297.229 334.617 297.229ZM334.617 263.766C322.498 263.766 312.675 273.591 312.675 285.708C312.675 297.826 322.498 307.65 334.617 307.65C346.735 307.65 356.56 297.826 356.56 285.708C356.56 273.591 346.735 263.766 334.617 263.766Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M285.475 274.205V280.257C285.475 287.099 291.021 292.646 297.864 292.646H434.34C447.093 292.646 458.054 285.08 463.054 274.205H285.475Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M334.617 297.229C328.255 297.229 323.097 292.071 323.097 285.708C323.097 279.345 328.255 274.187 334.617 274.187C340.979 274.187 346.137 279.345 346.137 285.708C346.137 292.071 340.979 297.229 334.617 297.229Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M334.617 297.229C328.255 297.229 323.097 292.071 323.097 285.708C323.097 279.345 328.255 274.187 334.617 274.187C340.979 274.187 346.137 279.345 346.137 285.708C346.137 292.071 340.979 297.229 334.617 297.229Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M416.808 297.229C410.445 297.229 405.287 292.071 405.287 285.708C405.287 279.345 410.445 274.187 416.808 274.187C423.17 274.187 428.328 279.345 428.328 285.708C428.328 292.071 423.17 297.229 416.808 297.229Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M416.808 297.229C410.445 297.229 405.287 292.071 405.287 285.708C405.287 279.345 410.445 274.187 416.808 274.187C423.17 274.187 428.328 279.345 428.328 285.708C428.328 292.071 423.17 297.229 416.808 297.229Z",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_146_3690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 529.945,
    height: 309.18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntro);
export default __webpack_public_path__ + "static/media/intro.71fb74a9.svg";
export { ForwardRef as ReactComponent };